import React from "react";

export default function Hero() {
  return (
    <section
      id="top"
      className="bg-gradient-brand position-relative overflow-hidden"
      style={{ paddingTop: "9.5rem", paddingBottom: "6rem" }}
    >
      <div className="blob" style={{ width: 420, height: 420, background: "rgba(7,179,158,0.3)", top: "-140px", right: "-100px" }} aria-hidden="true" />
      <div className="blob" style={{ width: 320, height: 320, background: "rgba(22,64,110,0.4)", bottom: "-160px", left: "-80px" }} aria-hidden="true" />

      <div className="container position-relative">
        <div className="row align-items-center g-5">
          <div className="col-lg-12">
            <div className="eyebrow mb-4">
              Systems integration &amp; software consulting
            </div>
            <h1
              className="display-font text-white mb-4"
              style={{ fontSize: "clamp(2.4rem, 5vw, 3.9rem)", lineHeight: 1.08, fontWeight: 600 }}
            >
              We connect the systems your business already trusts
            </h1>
            <p
              className="mb-5"
              style={{ color: "rgba(255,255,255,0.78)", fontSize: "1.15rem",lineHeight: 1.65 }}
            >
              GAPNIX SOLUTIONS LLP designs, integrates, and supports complex
              software systems — turning disconnected tools, legacy
              platforms, and custom applications into one dependable
              architecture.
            </p>
            <div className="d-flex flex-wrap gap-3 mb-5">
              <a href="#contact" className="btn-brand text-decoration-none">
                Talk to an engineer
              </a>
              <a href="#services" className="btn-outline-brand text-decoration-none">
                See what we build
              </a>
            </div>
            <div className="glass-panel d-inline-flex flex-wrap gap-4 gap-md-5 px-4 py-2">
              {["INTEGRATE", "DESIGN", "BUILD", "DELIVER"].map((word, i) => (
                <span key={word} className="mono-label" style={{ color: "rgba(255,255,255,0.75)" }}>
                  {String(i + 1).padStart(2, "0")} — {word}
                </span>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}